import { APP_INITIALIZER, LOCALE_ID, NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import localeFr from '@angular/common/locales/fr';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { registerLocaleData } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { JwtHelperService, JWT_OPTIONS } from '@auth0/angular-jwt';
import { ModalModule } from 'ngx-bootstrap/modal';
import { RequestInterceptor } from './misc/request-interceptor.misc';
import { SigninComponent } from './auth/signin/signin.component';
import { ThemeService } from './services/theme.service';
import { SignupComponent } from './auth/signup/signup.component';
import { ForgotPasswordComponent } from './auth/forgot-password/forgot-password.component';
import { ResetPasswordComponent } from './auth/reset-password/reset-password.component';
import { AccountActivationComponent } from './auth/account-activation/account-activation.component';
import { ResendEmailComponent } from './auth/resend-email/resend-email.component';
import { ConfigService } from './site/serviices/config.service';
import { firstValueFrom } from 'rxjs';

registerLocaleData(localeFr);

export function initAppConfig(configService: ConfigService) {
  return () => firstValueFrom(configService.loadConfigs(true));
}

@NgModule({
  declarations: [
    AppComponent,
    SigninComponent,
    SignupComponent,
    ForgotPasswordComponent,
    ResetPasswordComponent,
    AccountActivationComponent,
    ResendEmailComponent
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    FormsModule,
    HttpClientModule,
    ReactiveFormsModule,
    ModalModule.forRoot(),
  ],
  providers: [
    { provide: LOCALE_ID, useValue: "fr-FR", },
    {
      provide: APP_INITIALIZER,
      useFactory: initAppConfig,
      deps: [ConfigService],
      multi: true
    },
    { provide: HTTP_INTERCEPTORS, useClass: RequestInterceptor, multi: true },
    { provide: JWT_OPTIONS, useValue: JWT_OPTIONS },
    JwtHelperService,
    ThemeService
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
